import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/feature/auth/hooks/useAuth';

import { ROUTES } from './routeConstants';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className='flex h-screen items-center justify-center bg-gray-50 text-sm text-gray-500'>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
